// src/components/lesson/KnowledgeCheckFeedback.jsx

import React from "react";
import LessonShell from "./LessonShell";
import { playLessonSound } from "../../lib/learning/lessonSounds";



const TEMP_CORRECT_IMAGE =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Hands_Up.png";

const TEMP_INCORRECT_IMAGE =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Stages/Stage%201/L1/Gwin_Thinking.png";

export default function KnowledgeCheckFeedback({
  status = "correct",

  correctFeedbackText = "",
  incorrectFeedbackText = "",
  incorrectSupportText = "",

  onContinue,
  onRetry,

  progressStep = 1,
  progressTotal = 11,

  correctImageSrc =
    TEMP_CORRECT_IMAGE,

  incorrectImageSrc =
    TEMP_INCORRECT_IMAGE,
}) {
  const isCorrect =
    status ===
    "correct";

  const imageSrc =
    isCorrect
      ? correctImageSrc
      : incorrectImageSrc;

  /*
   * Canva defaults.
   *
   * Sanity text overrides these whenever
   * feedback content exists.
   */
  const mainText =
    isCorrect
      ? (
          correctFeedbackText ||
          "Financial control starts by knowing where to look first. You do not need to fix everything at once."
        )
      : (
          incorrectFeedbackText ||
          "Financial control does not mean doing everything at once or becoming an accountant."
        );

  const supportText =
    !isCorrect
      ? (
          incorrectSupportText ||
          "Start with this question:\nWhat should I check first?"
        )
      : "";

      
        
  // Play the Correct Answer sound once
  const correctSoundPlayedRef = React.useRef(false);

  React.useEffect(() => {
    if (status !== "correct") {
      correctSoundPlayedRef.current = false;
      return;
    }

    if (correctSoundPlayedRef.current) {
      return;
    }

    correctSoundPlayedRef.current = true;

    playLessonSound("correct");
  }, [status]);



  
  return (
    <LessonShell
      progressStep={progressStep}
      progressTotal={progressTotal}
      showBack={isCorrect}
      backLabel="Back"
      showNext={isCorrect}
      nextLabel="Next"
      onNext={isCorrect ? onContinue : undefined}
      contentClassName="pt-6"
    >

      <section
        className="
          mx-auto
          flex
          w-full
          max-w-[600px]
          flex-col
          items-center
          text-center
        "
      >
        {/*
         * PENGUIN
         */}
        {!!imageSrc && (
          <img
            src={
              imageSrc
            }
            alt=""
            aria-hidden="true"
            className="
              mt-16
              h-auto
              w-[210px]
              max-w-[44vw]
              object-contain
              sm:w-[240px]
            "
            loading="eager"
            decoding="async"
            draggable="false"
          />
        )}

        {/*
         * RESULT TITLE
         */}
        <h1
          className="
            mt-8
            text-[39px]
            font-extrabold
            leading-none
            tracking-[-0.035em]
            text-[#111111]
            sm:text-[46px]
          "
        >
          {isCorrect
            ? "Correct!"
            : "Not quite."}
        </h1>

        {/*
         * EXPLANATION
         */}
        {!!mainText && (
          <p
            className="
              mt-14
              max-w-[560px]
              whitespace-pre-line
              text-[18px]
              font-medium
              leading-[1.55]
              text-[#151515]
              sm:text-[20px]
            "
          >
            {mainText}
          </p>
        )}

        {!!supportText && (
          <p
            className="
              mt-9
              max-w-[480px]
              whitespace-pre-line
              text-[18px]
              font-medium
              leading-[1.55]
              text-[#151515]
              sm:text-[20px]
            "
          >
            {supportText}
          </p>
        )}

        {/*
         * INCORRECT → REVIEW
         *
         * Canva specifically sends the
         * learner back to retry/review.
         */}
        {!isCorrect && (
          <button
            type="button"
            onClick={
              onRetry
            }
            className="
              mt-12
              flex
              h-[58px]
              min-w-[180px]
              items-center
              justify-center
              rounded-[10px]
              bg-[#FF914D]
              px-7
              text-[16px]
              font-bold
              text-white
              transition
              hover:bg-[#F5833F]
              active:scale-[0.98]
            "
          >
            <span>
              Review
            </span>

            <span
              className="
                ml-8
                text-[25px]
                font-normal
                leading-none
              "
              aria-hidden="true"
            >
              →
            </span>
          </button>
        )}
      </section>
    </LessonShell>
  );
}